import { IDEA_STATUSES, IDEA_STATUS_LABELS } from '@cult/domain';
import type { IdeaStatus } from '@cult/schemas';
import { App as AntApp } from 'antd';
import { useState } from 'react';
import useTransitionIdea from './use-transition';

export const STATUS_ACTION_LABEL: Record<IdeaStatus, string> = {
  [IDEA_STATUSES.KIV]: 'Keep in view',
  [IDEA_STATUSES.ACCEPTED]: 'Accept',
  [IDEA_STATUSES.CLOSED]: 'Close',
};

export const NOTE_REQUIRED_FOR: ReadonlyArray<IdeaStatus> = [IDEA_STATUSES.CLOSED];

export const useIdeaTransition = (ideaId: string) => {
  const transition = useTransitionIdea();
  const { message } = AntApp.useApp();
  const [target, setTarget] = useState<IdeaStatus | null>(null);
  const [note, setNote] = useState('');

  const open = (to: IdeaStatus) => {
    setTarget(to);
    setNote('');
  };

  const close = () => {
    setTarget(null);
    setNote('');
  };

  const confirm = () => {
    if (!target) return;
    transition.mutate(
      { ideaId, to: target, note: note.trim() || undefined },
      {
        onSuccess: (next) => {
          message.success(`Moved to ${IDEA_STATUS_LABELS[next.status]}`);
          close();
        },
        onError: (err) => message.error(`Couldn't transition: ${err.message}`),
      },
    );
  };

  return { target, note, setNote, open, close, confirm, isPending: transition.isPending };
};
